import { Provider } from "./provider/Provider";

const TopluMailService = {
  tasarimListesi: () => {
    return Provider({
      methodName: "Module/TopluMail/TasarimListesi",
    });
  },
  tasarimEkle: ({ tasarimAdi, tasarimData }) => {
    return Provider({
      tasarimAdi,
      tasarimData,
      methodName: "Module/TopluMail/TasarimEkle",
    });
  },
  tasarimDetay: ({ tasarimCode }) => {
    return Provider({
      tasarimCode,
      methodName: "Module/TopluMail/TasarimDetay",
    });
  },
  tasarimiKaldir: ({ tasarimCode }) => {
    return Provider({
      tasarimCode,
      methodName: "Module/TopluMail/TasarimiKaldir",
    });
  },
};

export default TopluMailService;
